import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import HomeEs from "./pages/HomeEs";
import Firm from "./pages/Firm";
import FirmEs from "./pages/FirmEs";
import PracticeAreas from "./pages/PracticeAreas";
import PracticeAreasEs from "./pages/PracticeAreasEs";
import Contact from "./pages/Contact";
import ContactEs from "./pages/ContactEs";
import FreeConsultation from "./pages/FreeConsultation";
import FreeConsultationEs from "./pages/FreeConsultationEs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Routes>
          {/* English Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/firm" element={<Firm />} />
          <Route path="/practice-areas" element={<PracticeAreas />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/free-consultation" element={<FreeConsultation />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
          {/* Spanish Routes */}
          <Route path="/es" element={<HomeEs />} />
          <Route path="/es/firma" element={<FirmEs />} />
          <Route path="/es/areas-de-practica" element={<PracticeAreasEs />} />
          <Route path="/es/contacto" element={<ContactEs />} />
          <Route path="/es/consulta-gratuita" element={<FreeConsultationEs />} />
          <Route path="/es/politica-privacidad" element={<PrivacyPolicy />} />
          <Route path="/es/terminos-servicio" element={<TermsOfService />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
